export default {
  bull: require('assets/primary-interface/bull.svg'),
  chick: require('assets/primary-interface/chick.svg'),
  crab: require('assets/primary-interface/crab.svg'),
  fox: require('assets/primary-interface/fox.svg'),
  hedgehog: require('assets/primary-interface/hedgehog.svg'),
  hippopotamus: require('assets/primary-interface/hippopotamus.svg'),
  koala: require('assets/primary-interface/koala.svg'),
  lemur: require('assets/primary-interface/lemur.svg'),
  pig: require('assets/primary-interface/pig.svg'),
  tiger: require('assets/primary-interface/tiger.svg'),
  whale: require('assets/primary-interface/whale.svg'),
  zebra: require('assets/primary-interface/zebra.svg')
};


// WEBPACK FOOTER //
// ./src/components/Avatar/avatars.js